import styled from 'styled-components';

export const Label = styled.label``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  & label {
    margin: 0px;
    font-size: 1em;
    font-weight: bold;
    text-transform: uppercase;
  }
  & input {
    width: 95%;
    text-align: center;
    font-size: 2.1em;
    font-weight: bold;
    border: 1px solid gray;
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
      background-color: rgba(0, 128, 0, 0.115);
    }
  }
  & button {
    color: #fff;
    width: 50px;
    z-index: 2;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
    border-top: 1px solid gray;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    background-color: #0095E8;
    padding: 0px;
    :disabled,
    :disabled i {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    &:focus {
      outline: none;
    }
    & i {
      color: #fff;
      font-size: 1.5em;
      padding: 0px;
    }
  }
`;

export const InputButtonGroup = styled.div`
  display: flex;
  width: 95%;
  height: 50px;
`;

export const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  & label {
    margin: 0px;
    font-size: 1em;
    font-weight: bold;
    text-transform: uppercase;
  }
  & span {
    /* background-color: yellow; */
    /* min-width: 90%; */
    width: 90%;
    padding: 0px;
    & input {
      /* width: 95%; */
      width: 100%;
      height: 46px;
      text-align: center;
      font-size: 2.1em;
      font-weight: bold;
      border: 1px solid gray;
      border-right: none;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      &:focus:-webkit-placeholder {
        color: transparent;
      }
      &:focus {
        outline: none;
        background-color: rgba(0, 128, 0, 0.115);
      }
    }
    & ul {
      width: 380px;
      resize: horizontal;
    }
    & ul,
    li {
      font-size: 1em;
      /* width: 100%; */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.active {
        /* width: calc(); */
      }
    }
  }
  & button {
    color: #fff;
    width: 50px;
    z-index: 2;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
    border-top: 1px solid gray;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    background-color: #0095E8;
    padding: 0px;
    :disabled,
    :disabled i {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    &:focus {
      outline: none;
    }
    & i {
      color: #fff;
      font-size: 1.5em;
      padding: 0px;
    }
  }
`;
